module.exports = __webpack_public_path__ + "img/nickname.3f1eedc2.svg";